import { IsActiveModel } from './IsActiveModel';
import { Gender } from './Gender';
import { EmployeeTypeModel } from './employeeTypeModel';
import { MediCateCode,cookingMethod } from './MediCateCode';
import { UnSelected } from './UnSelected';
import { MediPurchaseUnit } from './MediPurchaseUnit';
import { MediStockUnit } from './MediStockUnit';
import { MediCalcBy } from './MediCalcBy';
import { InActive, Normal_Yes_No_Class, Report_Package_Type_Model, LoginUserActive, Report_SalesMonth_Type_Model, PaymentMethodStatusModel, JournalTypeClass } from './InActive';
import { Booking, BookingModel } from './Booking';
import { Payment } from './Payment';
import { Title, NewOldPatientTitle } from './Title';
import { PatientRefRelation } from './PatientRefRelation';
import { ItemUnit } from './ItemUnit';
import { ItemCalcBy } from './ItemCalcBy';
import { SpecialPaymentMethod } from './SpecialPaymentMethod';
import { GRNCateCode } from './GRNCateCode';
import { tInvtModel_invtType, tInvtModel_invtSubType } from '../tInvtModel';
import { GroupType, BSPL, AccType, DrCr, AllowNegBal, Disable } from './ChartAccOptions';
import { Month } from './month';

import { elementListModel } from '../tempLetter/letterElementModel';


export class SystemDefaultModel {
    static Language_Chinese: string = 'zh-TW';
    static Language_English: string = 'en-US';

    static SaveKey: string = "F4";
    static ResetKey: string = "F2";

}





export class EnglishDefaultModel {

    static MonthList = [
        new Month(Month.January,'January'),
        new Month(Month.February,'February'),
        new Month(Month.March,'March'),
        new Month(Month.April,'April'),
        new Month(Month.May,'May'),
        new Month(Month.June,'June'),
        new Month(Month.July,'July'),
        new Month(Month.August,'August'),
        new Month(Month.September,'September'),
        new Month(Month.October,'October'),
        new Month(Month.November,'November'),
        new Month(Month.December,'December'),
    ];

    static groupTypeList = [
        new GroupType(GroupType.ReportTitle, 'Report Title'),
        new GroupType(GroupType.VoucherEntry, 'Voucher Entry'),
    ];

    static Normal_Yes_No_ClassList: Normal_Yes_No_Class[] = [
        new Normal_Yes_No_Class(Normal_Yes_No_Class.N, 'N'),
        new Normal_Yes_No_Class(Normal_Yes_No_Class.Y, 'Y')
    ];

    static isActiveChooseList = [new IsActiveModel('Y', 'Y'), new IsActiveModel('N', 'N')];
    // static GenderList = [
    //     new Gender(Gender.Female, 'F'),
    //     new Gender(Gender.Male, 'M'),
    //     new Gender(Gender.Other, 'O')
    // ];
    static EmployeeTypeList = [
        new EmployeeTypeModel(EmployeeTypeModel.Doctor, 'Doctor'),
        new EmployeeTypeModel(EmployeeTypeModel.Doctor_Assistant, 'Doctor_Assistant'),
        new EmployeeTypeModel(EmployeeTypeModel.Hunchun_Coach, 'Hunchun_Coach'),
        new EmployeeTypeModel(EmployeeTypeModel.Physical_Therapist, 'Physical_Therapist'),
        new EmployeeTypeModel(EmployeeTypeModel.Pharmacist, 'Pharmacist'),
        new EmployeeTypeModel(EmployeeTypeModel.Administration_Manager, 'Administration_Manager'),
        new EmployeeTypeModel(EmployeeTypeModel.Administration_Assistant, 'Administration_Assistant')
    ];
    static MediCateCodeList = [
        new MediCateCode(MediCateCode.Herb, 'Herb'),
        new MediCateCode(MediCateCode.Pill, 'Pill'),
        new MediCateCode(MediCateCode.ConcMedi, 'Conc. Medicine'),
        new MediCateCode(MediCateCode.MediPowder, 'Medicine Powder'),
    ];
    static PresMediCateCodeList = [
        new MediCateCode(MediCateCode.Herb, 'Herb'),
        new MediCateCode(MediCateCode.Pill, 'Pill'),
        new MediCateCode(MediCateCode.ConcMedi, 'Conc. Medicine'),
        // new MediCateCode(MediCateCode.MediPowder, '中藥粉'),
    ];
    static UnSelectedList = [
        new UnSelected(UnSelected.UnSelectedText, '<Unselected>')
    ];

    static MediCalcByList = [
        new MediCalcBy(MediCalcBy.Balance, 'Balance'),
        new MediCalcBy(MediCalcBy.Standard, 'Standard')
    ];
    static InActiveList = [
        new InActive(InActive.N, 'N'),
        new InActive(InActive.Y, 'Y')
    ];

    static JournalTypeList = [
        new InActive(JournalTypeClass.PV, 'PV'),
        new InActive(JournalTypeClass.JV, 'JV')
    ];

    static LoginUserActiveList = [
        new LoginUserActive(LoginUserActive.N, 'N'),
        new LoginUserActive(LoginUserActive.Y, 'Y')
    ];
    static PaymentList = [
        new Payment(Payment.COD, 'C.O.D.'),
        new Payment(Payment.Day30, '30 days'),
        new Payment(Payment.Day14, '14 days'),
        new Payment(Payment.Day7, '7 days')
    ];
    // static TitleList = [
    //     // new Title(0, ''),
    //     new Title(Title.Ms, 'Ms'),
    //     new Title(Title.Mr, 'Mr'),
    //     new Title(Title.Mrs, 'Mrs'),
    // ];
    static PatientRefRelationList = [
        // new PatientRefRelation(PatientRefRelation.Friend, 'Friend'),
        // new PatientRefRelation(PatientRefRelation.Father, 'Father'),
        // new PatientRefRelation(PatientRefRelation.Mother, 'Mother'),
        // new PatientRefRelation(PatientRefRelation.Son, 'Son'),
        // new PatientRefRelation(PatientRefRelation.Spouse, 'Spouse'),
        // new PatientRefRelation(PatientRefRelation.Brother, 'Brother'),
        // new PatientRefRelation(PatientRefRelation.Relative, 'Relative'),
        // new PatientRefRelation(PatientRefRelation.Colleague, 'Colleague'),

        new PatientRefRelation(PatientRefRelation.Null, ''),
        new PatientRefRelation(PatientRefRelation.Friend, '朋友/家人推薦'),
        new PatientRefRelation(PatientRefRelation.Staff, '員工推薦'),
        new PatientRefRelation(PatientRefRelation.Web, '互聯網搜尋'),
        new PatientRefRelation(PatientRefRelation.Facebook, 'Facebook'),
        new PatientRefRelation(PatientRefRelation.NewsPaper1, 'Sky Post'),
        new PatientRefRelation(PatientRefRelation.NewsPaper2, 'Sing Tao'),
        new PatientRefRelation(PatientRefRelation.HSBank, '恒生銀行'),
        new PatientRefRelation(PatientRefRelation.Hotel, '景灣酒店'),
        new PatientRefRelation(PatientRefRelation.Ads, '樓下廣告牌'),

        new PatientRefRelation(PatientRefRelation.OldPatient, '舊病人'),
        new PatientRefRelation(PatientRefRelation.Manager, '由經紀推薦'),
        new PatientRefRelation(PatientRefRelation.Google, 'Google 谷歌'),
        new PatientRefRelation(PatientRefRelation.Yahoo, 'Yahoo 雅虎'),
        new PatientRefRelation(PatientRefRelation.Baidu, 'Baidu 百度'),
        new PatientRefRelation(PatientRefRelation.EABank, '東亞銀行'),
        new PatientRefRelation(PatientRefRelation.Other, 'Other'),
    ];

    // static ItemUnitList = [
    //     new ItemUnit(ItemUnit.Times, 'Times'),
    //     new ItemUnit(ItemUnit.Courses, 'Courses'),
    //     new ItemUnit(ItemUnit.Pcs, 'Pcs'),
    //     new ItemUnit(ItemUnit.Packs, 'Packs'),
    // ];

    static ItemCalcByList = [
        new ItemCalcBy(ItemCalcBy.None, 'None'),
        new ItemCalcBy(ItemCalcBy.Balance, 'Balance'),
        new ItemCalcBy(ItemCalcBy.Standard, 'Standard')
    ];

    static ItemCalcByListSelectOnly = [
        new ItemCalcBy(ItemCalcBy.Balance, 'Balance'),
        new ItemCalcBy(ItemCalcBy.Standard, 'Standard')
    ];

    static SpecialPaymentMethodList = [
        new SpecialPaymentMethod(SpecialPaymentMethod.Normal, 'Normal'),
        new SpecialPaymentMethod(SpecialPaymentMethod.HealthCareVoucher, 'Health Care Voucher')
    ];

    static GRNCateCodeList = [
        new GRNCateCode(GRNCateCode.Herb, 'Herb'),
        new GRNCateCode(GRNCateCode.Pill, 'Pill'),
        new GRNCateCode(GRNCateCode.ConcMedi, 'ConcMedi'),
        new GRNCateCode(GRNCateCode.Powder, 'Powder'),
        new GRNCateCode(GRNCateCode.StockItem, 'StockItem')
    ];

    static StockReportCateCodeList = [
        new GRNCateCode(GRNCateCode.Null, ''),
        new GRNCateCode(GRNCateCode.Herb, 'Drug'),
        // new GRNCateCode(GRNCateCode.Pill, 'Anti-inflammation'),
        // new GRNCateCode(GRNCateCode.ConcMedi, 'Allergy'),
      //  new GRNCateCode(GRNCateCode.Powder, '零售中草藥'),
        new GRNCateCode(GRNCateCode.StockItem, 'Item'),
    ];

    static StockMovementReportCateCodeList = [

        new GRNCateCode(GRNCateCode.Herb, 'Pain Relief'),
        new GRNCateCode(GRNCateCode.Pill, 'Anti-inflammation'),
        new GRNCateCode(GRNCateCode.ConcMedi, 'Allergy'),
      //  new GRNCateCode(GRNCateCode.Powder, '零售中草藥'),
        new GRNCateCode(GRNCateCode.StockItem, 'Retail Product'),
    ];

    static invtTypeList = [
        new tInvtModel_invtType(tInvtModel_invtType.Inbound,'入庫','Inbound'),
        new tInvtModel_invtType(tInvtModel_invtType.Outbound,'出庫','Outbound'),
        // new tInvtModel_invtType(tInvtModel_invtType.Inbound,"MonthEndBalance","MonthEndBalance"),
    ];

    static invtSubTypeList = [
        new tInvtModel_invtSubType(tInvtModel_invtSubType.GRN,'GRN','GRN'),
        new tInvtModel_invtSubType(tInvtModel_invtSubType.StockIn,'入庫','StockIn'),
        new tInvtModel_invtSubType(tInvtModel_invtSubType.Void,'註銷','Void'),
        new tInvtModel_invtSubType(tInvtModel_invtSubType.Sales,'售出','Sales'),
        new tInvtModel_invtSubType(tInvtModel_invtSubType.StockOut,'出庫','StockOut'),
        new tInvtModel_invtSubType(tInvtModel_invtSubType.MonthEndBalance,'MonthEndBalance','MonthEndBalance'),

    ];


    static packageReportType = [
        new Report_Package_Type_Model(Report_Package_Type_Model.PACKAGE, 'Package'),
        new Report_Package_Type_Model(Report_Package_Type_Model.PREPAY, 'Prepay')
    ];

    static salesMonthReportType = [

        new Report_SalesMonth_Type_Model(Report_SalesMonth_Type_Model.ITEM, 'Item/Service'),
        new Report_SalesMonth_Type_Model(Report_SalesMonth_Type_Model.PACKAGE, 'Package')
    ];


    static salesSummary_paymentMethodStatusList = [

        new Report_SalesMonth_Type_Model(PaymentMethodStatusModel.ALL, 'All'),
        new Report_SalesMonth_Type_Model(PaymentMethodStatusModel.ACTIVE, 'Active'),
        new Report_SalesMonth_Type_Model(PaymentMethodStatusModel.INACTIVE, 'Inactive'),
        new Report_SalesMonth_Type_Model(PaymentMethodStatusModel.NOTHING, 'Nothing')


    ];


    static IncludeZeroList = [
        new InActive(InActive.N, 'N'),
        new InActive(InActive.Y, 'Y')
    ];
}

export class ChineseDefaultModel {

    static JournalTypeList = [
        new InActive(JournalTypeClass.PV, 'Payment'),
        new InActive(JournalTypeClass.JV, 'Journal')
    ];

    static MonthList = [
        new Month(Month.January,'一月'),
        new Month(Month.February,'二月'),
        new Month(Month.March,'三月'),
        new Month(Month.April,'四月'),
        new Month(Month.May,'五月'),
        new Month(Month.June,'六月'),
        new Month(Month.July,'七月'),
        new Month(Month.August,'八月'),
        new Month(Month.September,'九月'),
        new Month(Month.October,'十月'),
        new Month(Month.November,'十一月'),
        new Month(Month.December,'十二月'),
    ];

    static backgroundColor ='#f2f2f2';
    static Normal_Yes_No_ClassList: Normal_Yes_No_Class[] = [
        new Normal_Yes_No_Class(Normal_Yes_No_Class.N, '否'),
        new Normal_Yes_No_Class(Normal_Yes_No_Class.Y, '是')
    ];


    static isActiveChooseList = [new IsActiveModel('Y', 'Y'), new IsActiveModel('N', 'N')];
     static GenderList = [
         new Gender(Gender.Female, 'F'),
         new Gender(Gender.Male, 'M'),
        //  new Gender(Gender.Other, 'Other')
     ];
    static EmployeeTypeList = [
        new EmployeeTypeModel(EmployeeTypeModel.Doctor, '醫師'),
        new EmployeeTypeModel(EmployeeTypeModel.Doctor_Assistant, '醫師助理'),
        new EmployeeTypeModel(EmployeeTypeModel.Hunchun_Coach, '詠春教練'),
        new EmployeeTypeModel(EmployeeTypeModel.Physical_Therapist, '推拿師'),
        new EmployeeTypeModel(EmployeeTypeModel.Pharmacist, '藥劑師'),
        new EmployeeTypeModel(EmployeeTypeModel.Administration_Manager, '行政經理'),
        new EmployeeTypeModel(EmployeeTypeModel.Administration_Assistant, '行政助理')
    ];
    static MediCateCodeList = [
        new MediCateCode(MediCateCode.Herb, 'Drug'),
        new MediCateCode(MediCateCode.ConcMedi, 'Drug'),
      //  new MediCateCode(MediCateCode.MediPowder, '零售中草藥'),
        new MediCateCode(MediCateCode.Pill, 'Drug'),
        //new MediCateCode(MediCateCode.Pill, '藥丸(膏散丸丹)'),


    ];
    static cookingMethod=[
        new cookingMethod("",""),
        new cookingMethod("1","先煎"),
        new cookingMethod("2","後下"),
        new cookingMethod("3","沖服"),
    ];
    static PresMediCateCodeList = [
        new MediCateCode(MediCateCode.Herb, 'Drug'),
        new MediCateCode(MediCateCode.ConcMedi, 'Drug'),
    ];
    static UnSelectedList = [
        new UnSelected(UnSelected.UnSelectedText, '<未選取1>')
    ];

    static MediCalcByList = [
        new MediCalcBy(MediCalcBy.Balance, 'Last Cost'),
        new MediCalcBy(MediCalcBy.Standard, 'Standard Cost')
    ];
    static InActiveList = [
        new InActive(InActive.N, 'No'),
        new InActive(InActive.Y, 'Yes')
    ];
    static LoginUserActiveList = [
        new LoginUserActive(LoginUserActive.N, 'No'),
        new LoginUserActive(LoginUserActive.Y, 'Yes')
    ];
    static PaymentList = [
        new Payment(Payment.COD, 'C.O.D.'),
        new Payment(Payment.Day30, '30 days'),
        new Payment(Payment.Day14, '14 days'),
        new Payment(Payment.Day7, '7 days')
    ];


    static PatientRefRelationList = [

        new PatientRefRelation(PatientRefRelation.Null, ''),
        new PatientRefRelation(PatientRefRelation.Friend, '朋友/家人推薦'),
        new PatientRefRelation(PatientRefRelation.Staff, '員工推薦'),
        new PatientRefRelation(PatientRefRelation.Web, '互聯網搜尋'),
        new PatientRefRelation(PatientRefRelation.Facebook, 'Facebook'),
        new PatientRefRelation(PatientRefRelation.NewsPaper1, 'Sky Post'),
        new PatientRefRelation(PatientRefRelation.NewsPaper2, 'Sing Tao'),
        new PatientRefRelation(PatientRefRelation.HSBank, '恒生銀行'),
        new PatientRefRelation(PatientRefRelation.Hotel, '景灣酒店'),
        new PatientRefRelation(PatientRefRelation.Ads, '樓下廣告牌'),

        new PatientRefRelation(PatientRefRelation.OldPatient, '舊病人'),
        new PatientRefRelation(PatientRefRelation.Manager, '由經紀推薦'),
        new PatientRefRelation(PatientRefRelation.Google, 'Google 谷歌'),
        new PatientRefRelation(PatientRefRelation.Yahoo, 'Yahoo 雅虎'),
        new PatientRefRelation(PatientRefRelation.Baidu, 'Baidu 百度'),
        new PatientRefRelation(PatientRefRelation.EABank, '東亞銀行'),

        new PatientRefRelation(PatientRefRelation.Other, 'Other'),
    ];




    static ItemCalcByList = [
        new ItemCalcBy(ItemCalcBy.None, '沒有'),
        new ItemCalcBy(ItemCalcBy.Balance, 'Last Cost'),
        new ItemCalcBy(ItemCalcBy.Standard, 'Standard Cost')
    ];

    static ItemCalcByListSelectOnly = [
        new ItemCalcBy(ItemCalcBy.Balance, 'Last Cost'),
        new ItemCalcBy(ItemCalcBy.Standard, 'Standard Cost')
    ];

    static SpecialPaymentMethodList = [
        new SpecialPaymentMethod(SpecialPaymentMethod.Normal, '普通'),
        new SpecialPaymentMethod(SpecialPaymentMethod.HealthCareVoucher, '醫療券'),
        // new SpecialPaymentMethod(SpecialPaymentMethod.HealthCareVoucher, '醫療券'),

    ];

    static GRNCateCodeList = [
        new GRNCateCode(GRNCateCode.Herb, 'Drug'),
        // new GRNCateCode(GRNCateCode.ConcMedi, 'Allergy'),
      //  new GRNCateCode(GRNCateCode.Powder, '零售中草藥'),
        // new GRNCateCode(GRNCateCode.Pill, 'Anti-inflammation'),
        new GRNCateCode(GRNCateCode.StockItem, 'Item'),
    ];

    static StockReportCateCodeList = [
        new GRNCateCode(GRNCateCode.Null, ''),
        new GRNCateCode(GRNCateCode.Herb, 'Drug'),
        // new GRNCateCode(GRNCateCode.ConcMedi, 'Allergy'),
      //  new GRNCateCode(GRNCateCode.Powder, '零售中草藥'),
        // new GRNCateCode(GRNCateCode.Pill, 'Anti-inflammation'),
        new GRNCateCode(GRNCateCode.StockItem, 'Item'),
    ];

    static StockMovementReportCateCodeList = [

        new GRNCateCode(GRNCateCode.Herb, 'Drug'),
        // new GRNCateCode(GRNCateCode.ConcMedi, 'Allergy'),
      //  new GRNCateCode(GRNCateCode.Powder, '零售中草藥'),
        // new GRNCateCode(GRNCateCode.Pill, 'Anti-inflammation'),
        new GRNCateCode(GRNCateCode.StockItem, 'Item'),
    ];

    static invtTypeList = [
        new tInvtModel_invtType(tInvtModel_invtType.Inbound,'入庫','Inbound'),
        new tInvtModel_invtType(tInvtModel_invtType.Outbound,'出庫','Outbound'),
        // new tInvtModel_invtType(tInvtModel_invtType.Inbound,"MonthEndBalance","MonthEndBalance"),
    ];


   static invtSubTypeList = [
        new tInvtModel_invtSubType(tInvtModel_invtSubType.GRN,'GRN','GRN'),
        new tInvtModel_invtSubType(tInvtModel_invtSubType.StockIn,'入庫','StockIn'),
        new tInvtModel_invtSubType(tInvtModel_invtSubType.Void,'註銷','Void'),
        new tInvtModel_invtSubType(tInvtModel_invtSubType.Sales,'售出','Sales'),
        new tInvtModel_invtSubType(tInvtModel_invtSubType.StockOut,'出庫','StockOut'),
        new tInvtModel_invtSubType(tInvtModel_invtSubType.MonthEndBalance,'MonthEndBalance','MonthEndBalance'),

    ];


   static packageReportType = [

        new Report_Package_Type_Model(Report_Package_Type_Model.PACKAGE, '套票'),
        new Report_Package_Type_Model(Report_Package_Type_Model.PREPAY, '預付')
    ];

    static salesMonthReportType = [

        new Report_SalesMonth_Type_Model(Report_SalesMonth_Type_Model.ITEM, '產品服務'),
        new Report_SalesMonth_Type_Model(Report_SalesMonth_Type_Model.PACKAGE, '套票')
    ];



    static salesSummary_paymentMethodStatusList = [

        new Report_SalesMonth_Type_Model(PaymentMethodStatusModel.ALL, '所有'),
        new Report_SalesMonth_Type_Model(PaymentMethodStatusModel.ACTIVE, '使用中'),
        new Report_SalesMonth_Type_Model(PaymentMethodStatusModel.INACTIVE, '停用中'),
        new Report_SalesMonth_Type_Model(PaymentMethodStatusModel.NOTHING, '沒有')


    ];


    static IncludeZeroList = [
        new InActive(InActive.N, '否'),
        new InActive(InActive.Y, '是')
    ];




    static groupTypeList = [
        new GroupType(GroupType.ReportTitle, '報表行名稱用'),
        new GroupType(GroupType.VoucherEntry, '輸入憑證用'),
    ];


    static accBSPLList = [
        new BSPL(BSPL.BS, 'BS'),
        new BSPL(BSPL.PL, 'PL')
    ];

    static accTypeList = [

        new AccType(AccType.Assets, 'Assets'),
        new AccType(AccType.Liability, 'Liability'),
        new AccType(AccType.AR, 'AR'),
        new AccType(AccType.AP, 'AP'),
        new AccType(AccType.Capital, 'Capital'),

        new AccType(AccType.Bank, 'Bank'),
        new AccType(AccType.Retained_Earnings, 'Retained_Earnings'),
        new AccType(AccType.Expenses, 'Expenses'),
        new AccType(AccType.Income, 'Income'),
        new AccType(AccType.Exchange_Gain, 'Exchange_Gain'),

        new AccType(AccType.Exchange_Loss, 'Exchange_Loss'),
    ];

    static accDrCrList = [
        new DrCr(DrCr.Dr, 'Dr'),
        new DrCr(DrCr.Dr, 'Cr'),
    ];

    static accAllowNegBalList = [
        new AllowNegBal(AllowNegBal.N, 'N'),
        new AllowNegBal(AllowNegBal.Y, 'Y'),
    ];

    static accDisableList = [
        new Disable(Disable.N, 'N'),
        new Disable(Disable.Y, 'Y'),
    ];

    static letterElementList=[
        new elementListModel(10,"Consultation Date","#consult_Date"),
        new elementListModel(13,"Print Date","#print_Date"),
        new elementListModel(2,"Patient Name","#patientName"),
        new elementListModel(3,"Patient English Name","#patientName_ENG"),
        new elementListModel(1,"Patient ID","#patientID"),
        new elementListModel(19,"Patient HKID","#patientHKID"),
        new elementListModel(19,"Patient Full HKID","#patientFullHKID"),

        new elementListModel(19,"Non-HKID remark","#nonHKID_remark"),
        new elementListModel(5,"Patient DOB","#patient_DOB"),
        new elementListModel(4,"Patient Gender","#patient_gender"),
        new elementListModel(4,"Patient Address","#patient_address"),
        new elementListModel(4,"Patient Tel.","#patient_Tel"),
        new elementListModel(4,"Patient Other Tel.","#patient_Other_Tel"),
        new elementListModel(4,"Patient Pronouns.","#patient_Pronouns"),
        // new elementListModel(6,"Clinic Address 1","#clinic_address1"),
        // new elementListModel(7,"Clinic Address 2","#clinic_address2"),
        // new elementListModel(8,"Clinic Address 3","#clinic_address3"),
       // new elementListModel(9,"Consult No.","#consultNo"),

    //    new elementListModel(11,"Prescription No.","#presNo"),
      //  new elementListModel(12,"Shop Name","#shopName"),
        new elementListModel(17,"Treat Dr. Chinese Name","#treatDoctorName_CHI"),
        new elementListModel(17,"Treat Dr. English Name","#treatDoctorName_ENG"),
        new elementListModel(18,"Treat Doctor Receipt Title","#treatDoctor_ReceiptTitle"),
     //   new elementListModel(20,"Treat Dr. DrCMP","#treatDoctorDrCMP"),
        new elementListModel(15,"Case Dr. Chinese Name","#caseDoctorName_CHI"),
        new elementListModel(15,"Case Dr. English Name","#caseDoctorName_ENG"),
        new elementListModel(16,"Case Doctor Receipt Title","#caseDoctor_ReceiptTitle"),
        new elementListModel(14,"Diagnosis","#consult_diagnosis"),
        new elementListModel(14,"Notes in consultation","#consult_notes"),

        new elementListModel(14,"Doctor's order","#consult_doctorOrder"),

        new elementListModel(14,"Allergy","#consult_allergy"),


    ];

}
